<template>
    <div id="app">
        <p class="h4 text-center pb-2" style="margin-top:-35px;">
            <span class="badge badge-secondary bg-animate bubble py-2 px-2">{{alert}}</span>
        </p>
        <el-container style="border: 1px solid #eee">
            <el-main style="background-color: white; overflow:hidden;" class="py-0 px-0">
                <el-form 
                    v-loading="loading"
                    :rules="rules"  
                    id="form" 
                    action="/add-product" 
                    method="POST" 
                    :inline="false" 
                    ref="form" 
                    :label-position="labelPosition" 
                    :model="form" 
                    label-width="500px"
                    size="large">
                    <input name="_token" v-model="form.token" type="hidden">
                    <input type="hidden" name="product_id" value="1">
                    <input type="hidden" name="excursion_id" value="1">

                    <el-row :gutter="20" v-if="showOptionSelected">
                        <el-col :span="24">
                            <el-tag
                                class="d-block tag-calendar"
                                type=""
                                closable
                                @close="showOptions"
                                > <i class="fas fa-camera-retro fa-lg mr-1"></i> {{optionSelected}}
                            </el-tag>
                        </el-col>
                    </el-row>

                    <el-row v-else>
                        <el-radio-group class="d-block" v-model="form.option" @change="selectOption">
                            <el-radio
                                class="options mb-2 mx-0 ellipsis"
                                v-for="item in options"
                                :key="item.id"
                                :label="item.id"
                                border>
                                <template v-slot:default>
                                    {{item.name}}
                                </template>
                            </el-radio>
                        </el-radio-group>
                    </el-row>
                    <el-form-item v-if="showDate">
                        <vuejs-datepicker  
                            :inline="true" 
                            :monday-first="true" 
                            :disabledDates="disabledDates"
                            v-model="form.date"
                            @selected="selectDate">
                        </vuejs-datepicker>
                    </el-form-item>
                    <input type="hidden" name="date" v-model="form.date">
                    
                    <el-row :gutter="20" v-if="showDateHuman">
                        <el-col :span="24">
                            <el-tag
                                class="d-block tag-calendar"
                                type=""
                                closable
                                @close="setState(1)"
                                > <i class="far fa-calendar-check fa-lg mr-1"></i> {{dateHuman}}
                            </el-tag>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-radio-group v-model="form.language" @change="selectLanguage" class="d-block tag-lang el-tag el-tag--large el-tag--light">
                            <i class="far fa-comment-dots fa-lg mr-1"></i>
                            <el-radio
                                class="ml-0 mr-2 mr-md-1 mr-lg-2 mr-xl-2 pr-0 pl-1"
                                v-for="item in languages_available"
                                :key="item.id"
                                :label="item.id"
                                >
                                <img :src="item.flag" :alt="item.name" :title="item.name">
                            </el-radio>
                        </el-radio-group>
                    </el-row>
                    <input type="hidden" name="language_id" v-model="form.language">


                    <el-form-item v-if="showTime">
                        <el-radio-group v-model="form.excursion_id" @change="selectExcursion" class="d-block tag-time el-tag el-tag--large el-tag--light">
                            <i class="far fa-clock fa-lg mr-1"></i>
                            <el-radio
                                class="ml-0 mr-2 pr-2"
                                v-for="item in times"
                                :key="item.id"
                                :label="item.id"
                                >{{item.name}}
                            </el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <input type="hidden" name="excursion_id" v-model="form.excursion_id">

                    <el-row v-if="showFaresAndSupplements" class="mb-1">
                        <el-col :span="24">
                            <p class="text-center text-primary pt-1 mb-0 border-top">
                                <span class="h6 font-weight-bold m-0"> {{ this.trans('vue.fares' )}} </span>
                            </p>
                            <p class="text-center text-danger p-0 m-0">
                                <span class="h7 font-weight-bold"> {{ this.alertAvailable}} </span>
                            </p>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10" 
                        v-for="(fare, index) in fares"
                        :key="fare.id"
                        :value="fare.id"
                        size="large"
                        class="mb-1"
                        v-if="showFaresAndSupplements">
                        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                            <p class="my-0 text-xs ellipsis">
                                {{fare.name}} 
                            </p>
                            <p class="my-0 small">
                                {{fare.price}}€
                                <el-tooltip class="item" v-if="fare.explanation!==''" effect="dark" placement="top-start">
                                    <div slot="content"><span v-html="fare.explanation"></span></div>
                                    <i class="el-icon-info"></i>
                                </el-tooltip>
                            </p>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item class="my-0">
                                <el-input-number 
                                    size="small"
                                    :min="0" 
                                    :max="10"
                                    placeholder="0"
                                    v-model="form.fares_selected[index]"
                                    @change="addOrUpdateFare(index, fare.id, fare.price)">
                                </el-input-number>
                                <input type="hidden" :name="'fare_'+fare.id" v-model="form.fares_selected[index]">
                            </el-form-item>
                        </el-col>
                        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                            <p v-model="form.fares_sel_lab[index]" class="mb-0 h5 text-muted text-right"> {{form.fares_sel_lab[index]}} </p>
                        </el-col>
                    </el-row>

                    <el-row v-if="showFaresAndSupplements" class="mb-1">
                        <el-col :span="24">
                            <p class="text-center text-primary pt-1 mb-0 border-top">
                                <span class="h6 font-weight-bold m-0"> {{ this.trans('vue.supplements' )}} </span>
                            </p>
                        </el-col>
                    </el-row>

                    <el-row :gutter="10" 
                        v-for="(supplement, index) in supplements"
                        :key="supplement.id + 'sup'"
                        :value="supplement.id"
                        size="large"
                        class="mb-1"
                        v-if="showFaresAndSupplements">
                        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                            <p class="my-0 text-xs ellipsis">{{supplement.name}}</p>
                            <p class="my-0">
                                {{supplement.price}}€
                                <el-tooltip class="item" effect="dark" v-if="supplement.explanation!==''" placement="top-start">
                                    <div slot="content"><span v-html="supplement.explanation"></span></div>
                                    <i class="el-icon-info"></i>
                                </el-tooltip>
                            </p>
                        </el-col>
                        <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                            <el-form-item>
                                <el-input-number 
                                    size="small"
                                    :min="0" 
                                    :max="10"
                                    placeholder="0"
                                    v-model="form.supplements_selected[index]"
                                    @change="addOrUpdateSupplement(index, supplement.id, supplement.price)">
                                </el-input-number>
                                <input type="hidden" :name="'supplement_'+supplement.id" v-model="form.supplements_selected[index]">
                            </el-form-item>
                        </el-col>
                        <el-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                            <p v-model="form.supplements_sel_lab[index]" class="mb-0 h5 text-muted text-right"> {{form.supplements_sel_lab[index]}} </p>
                        </el-col>
                    </el-row>
                    <el-row v-if="showFaresAndSupplements">
                        <el-col :span="24">
                            <p class="text-right text-primary pt-2 mb-0 border-top">
                                {{ this.trans('vue.total' )}} 
                                <span class="h4 font-weight-bold"> {{total}} <small>€</small></span>
                            </p>
                        </el-col>
                    </el-row>
                    <input type="hidden" name="paxs" v-model="form.paxs">
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <button href="#" type="submit" class="btn btn-secondary btn-lg btn-block" 
                                :disabled="!isFormValid()"> {{ this.trans('vue.book' )}}
                            </button>
                        </el-col>
                    </el-row>
                </el-form>
            </el-main>
        </el-container>
    </div>
</template>

<script>
    import Datepicker from 'vuejs-datepicker'

    export default {
        props: ['options',
                'languages',
                'dates_available_init', 
                'show_sessions',
                'tour_id'],
        components: {
            'vuejs-datepicker': Datepicker
        },

        methods: {
            trans(value){
                if (!value) return '';
                return  _.get(window.i18n, value);
            },
            selectOption(){
                this.setState(1);
                this.loading = true;
                axios.get("/api/date-languages/" + this.form.option)
                .then(response => {
                    this.languages_available = response.data[0].languages;
                    this.dates_enabled = response.data[0].dates;
                    this.dates_available = response.data[0].dates;
                    this.showOptionSelected = true;
                    EventBus.$emit('listen-option', this.form.option);
                    this.loading = false;
                })
                .catch(e => {
                    console.log(e.response);
                })
            },
            showOptions(){
                this.showOptionSelected = false;
            },
            // Paso 1: Se selecciona la fecha
                // Estado 1.1: No se ha seleccionado el idioma
                // Estado 1.2: Se ha seleccionado previamente el idioma
            selectDate(date_selected) {
                // Estado 1.1: No se ha seleccionado el idioma
                if(this.form.language == 0){
                    this.setState(1);
                    this.alert = this.trans('vue.select_language');
                    this.fillLanguages(date_selected);
                }// Estado 1.2: Se ha seleccionado previamente el idioma
                else{
                    this.form.date = date_selected;
                    this.setState(3);
                }
            },
            // Actualizamos los idiomas disponibles para la fecha seleccionada
            fillLanguages(date_selected){
                this.loading = true;
                axios.get("/api/languages/" + this.form.option + "/" + date_selected.toJSON())
                .then(response => {
                    this.languages_available = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    console.log(e.response);
                })
            },

            // Paso 2: Se selecciona el idioma
                // Estado 2.1: Se ha seleccionado previamente la fecha
                    //Estado 2.1.1: El idioma que se selecciona está disponible para esa fecha
                    //Estado 2.1.2: El idioma que se selecciona no está disponible para esa fecha
                // Estado 2.2: No se ha seleccionado previamente la fecha
            selectLanguage() {
                // Estado 2.2: No se ha seleccionado previamente la fecha, por lo que actualizaremos las fechas disponibles para ese idioma
                //console.log('this.form.date antes'+this.form.date);
                if(this.form.date == ''){
                    //console.log('this.form.date despues'+this.form.date);
                    //console.log('Estado 2.2');
                    this.loading = true;
                    axios.get("/api/excursions-lang/" + this.form.option + "/" + this.form.language)
                    .then(response => {
                        this.dates_enabled = response.data;
                        this.loading = false;
                    })
                    .catch(e => {
                        console.log(e.response);
                    })
                }
                else{ // Estado 2.1 Fecha seleccionada previamente
                    // Chequeamos si la fecha seleccionada esta disponible para el idioma que se ha seleccionado
                    //console.log('Estado 2.1');
                    this.loading = true;
                    axios.get("/api/date-available/" + this.form.option + "/" + this.form.language + "/" + this.form.date.toJSON())
                    .then(response => {
                        // Estado 2.1.1 Fecha disponible para este idioma
                        if(response.data==true){
                            this.setState(3);
                        }else// Caso 2.1.2  Fecha no disponible para este idioma, deseleccionamos la fecha y volvemos al estado 2 
                            this.setState(2);
                        this.loading = false;
                    })
                    .catch(e => {
                        console.log(e.response);
                    })
                }
            },
            // Paso 3: Se oculta el calendario, se muestra la fecha en formato texto y se cargan las sesiones
                // Caso 3.1: El tour tiene marcado que se muestren los horarios, se deben de mostrar los horarios
                    // Caso 3.1.1: Si sólo tiene un horario se autoselecciona el que hay y se muestran las tarifas y suplementos
                    // Caso 3.1.2: Si tiene más de un horario no se muestran las tarifas hasta que no seleccione un horario
                // Caso 3.2: El tour no tiene marcado que se muestren los horarios
                    // Caso 3.2.1: Si sólo tiene un horario se autoselecciona el que hay en hidden y se muestran las tarifas y suplementos
                    // Caso 3.2.2: Si tiene más de un horario no se muestran las tarifas hasta que no seleccione un horario
            fillTimes(){
                this.loading = true;
                axios.get("/api/excursions/" + this.form.option + "/" + this.form.language + "/" + this.form.date.toJSON())
                .then(response => {
                    this.times = response.data;
                    // Caso 3.1
                    if(this.show_sessions > 0){
                        //console.log('Estado 3.1');
                        this.alert = this.trans('vue.select_time');
                        this.showTime = true;
                        this.showFaresAndSupplements = false;
                    } // Caso 3.2
                    else{
                        //console.log('Estado 3.2');
                        this.form.excursion_id = response.data[0].id;
                        this.selectExcursion(response.data[0].id);
                        this.showFaresAndSupplements = true;
                    }
                    this.loading = false;
                })
                .catch(e => {
                    console.log(e.response);
                })
            },

            // Paso 4: Se cargan las tarifas y los suplementos cuando se selecciona una excursión
            selectExcursion(excursion_selected){
                this.loading = true;
                axios.get("/api/fares/" + excursion_selected)
                .then(response => {
                    this.form.fares_selected = [];
                    this.form.fares_sel_lab = [];
                    this.fares = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    console.log(e.response);
                })
                this.loading = true;
                axios.get("/api/supplements/" + excursion_selected)
                .then(response => {
                    this.form.supplements_selected = [];
                    this.form.supplements_sel_lab = [];
                    this.supplements = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    console.log(e.response);
                })
                this.loading = true;
                axios.get("/api/excursion-available/" + excursion_selected)
                .then(response => {
                    this.capacity = response.data;
                    this.loading = false;
                })
                .catch(e => {
                    console.log(e.response);
                })
                this.setState(4);
            },

            // Setea el formulario a diferentes estados:
                // Estado 1: reseteo a bajo nivel como si recargaras la página
                // Estado 2: reseteamos todo menos los idiomas, el idioma seleccionado y las fechas disponibles  
                // Estado 3: reseteamos todo menos los idiomas, el idioma seleccionado y las fechas disponibles
                // Estado 4: mostramos los horarios de las excursiones, las tarifas y los suplementos 
            setState(state){
                //console.log('Estado: '+ state);
                switch(state){
                    case 1:// Estado 1: reseteo a bajo nivel como si recargaras la página
                        this.showDate = true;
                        this.showDateHuman = false;
                        this.languages_available = this.languages;
                        this.dates_enabled = this.dates_available;
                        this.form.language = 0;
                        this.form.date = '';
                        this.resetExcursionFaresAndSupplements();
                        this.showTime = false;
                        this.showFaresAndSupplements = false;
                        this.alert = this.trans('vue.select_date');
                        break;
                    case 2:// Estado 2: reseteamos todo menos los idiomas, el idioma seleccionado y las fechas disponibles
                        this.showDate = true;
                        this.showDateHuman = false;
                        this.form.date = '';
                        this.resetExcursionFaresAndSupplements();
                        this.showTime = false;
                        this.showFaresAndSupplements = false;
                        this.alert = this.trans('vue.select_date');
                        break;
                    case 3:// Estado 3: Se oculta el calendario, se muestra la fecha en formato texto y se resetean las tarifas y suplementos
                        this.showDate = false;
                        this.showDateHuman = true;
                        this.formatDate();
                        this.resetExcursionFaresAndSupplements();
                        this.fillTimes();
                        break;
                    case 4: 
                        this.showFaresAndSupplements = true;
                        this.alert = this.trans('vue.select_fare');
                        break;
                }
            },
            resetExcursionFaresAndSupplements(){
                this.form.excursion_id = '';
                this.form.fares_selected = [];
                this.form.fares_sel_lab = [];
                this.form.supplements_selected = [];
                this.form.supplements_sel_lab = [];
            },
            addOrUpdateFare(index, fare_selected, price){
                this.fares[index].amount = this.form.fares_selected[index];
                this.form.fares_sel_lab[index] = this.form.fares_selected[index]*price + ' €' ;
            },
            addOrUpdateSupplement(index, supplement_selected, price){
                this.supplements[index].amount = this.form.supplements_selected[index];
                this.form.supplements_sel_lab[index] = this.form.supplements_selected[index]*price + ' €' ;
            },
            formatDate() {
                var monthNames = [
                    "January", "February", "March",
                    "April", "May", "June", "July",
                    "August", "September", "October",
                    "November", "December"
                ];
                var date = this.form.date;
                //console.log('form.date: ' + this.form.date);
                //console.log('date: ' + date);
                var day = date.getDate();
                var monthIndex = date.getMonth();
                var year = date.getFullYear();
                this.dateHuman = day + ' ' + monthNames[monthIndex] + ' ' + year;
            },
            
            isFormValid() {
                if(this.form.date && this.form.excursion_id && this.total>0 && this.capacity >= this.form.paxs){
                    this.alert = 'Book now';
                    return true;
                }
            },

        },
        computed: {
            alertAvailable(){
                if(this.capacity < this.form.paxs)
                    return 'Just ' + this.capacity + ' available';
            },
            disabledDates(){
                var self = this;
                return {
                    customPredictor: function(date) {
                        var year,month,day, current_date_enabled, current_date_enabled_sliced, d1;
                        var d2 = new Date(date.getFullYear(),date.getMonth(),date.getDate());
                        for (var i = 0; i < self.dates_enabled.length; i++) {
                            current_date_enabled = self.dates_enabled[i];
                            current_date_enabled_sliced = current_date_enabled.split("-");
                            year = current_date_enabled_sliced[0];
                            month = current_date_enabled_sliced[1]-1;
                            day = current_date_enabled_sliced[2];
                            d1 = new Date(year,month,day);
                            if(d1.getTime() === d2.getTime())
                                return false;
                        }
                        return true;
                    }   
                }
            },
            optionSelected(){
                var option_name = ''
                this.options.forEach(row => {
                    if(row.id == this.form.option)
                        option_name = row.name.substring(0,30)+"..";
                });
                return option_name;
            },
            total(){
                var total = 0;
                var paxs = 0;
                var faresLength = this.fares.length;
                for (var i = 0; i < faresLength; i++) {
                    paxs += this.fares[i].amount;
                    total = total + this.fares[i].amount*this.fares[i].price;
                }
                var supplementsLength = this.supplements.length;
                for (var i = 0; i < supplementsLength; i++) 
                    total = total + this.supplements[i].amount*this.supplements[i].price;
                this.form.paxs = paxs;
                return total;
            }
        },
        data() {
            return {
                labelPosition: 'top',
                dates_enabled: '',
                showOptionSelected: false,
                showDate: true,
                showDateHuman: false,
                showFaresAndSupplements: false,
                dateHuman: '',
                showTime: false,
                times: '',
                fares: '',
                alert: 'Book now',
                supplements: '',
                languages_available: [],
                capacity: 0,
                loading: false,
                dates_available: [],
                window: {
                    width: 0,
                    height: 0
                },
                form: {
                    token: window.axios.defaults.headers.common['X-CSRF-TOKEN'],
                    date: '',
                    language: '',
                    excursion_id: '',
                    fares_selected: [],
                    fares_sel_lab: [],
                    supplements_selected: [],
                    supplements_sel_lab: [],
                    paxs: 0,
                    option: 0,
                },
                rules: {
                },
            }
        },
        created() {
            EventBus.$on('select-option', (new_option) => {
                this.form.option = new_option;
                this.showOptionSelected = true;
                this.setState(1);
            });
            this.form.option = this.tour_id;
            this.dates_available = this.dates_available_init;
            this.setState(1);
        },
        filters: {
            translate: function (value) {
                if (!value) return '';
                return _.get(window.i18n, value);
            }
        }
    }
</script>
<style type="text/css">
    .options {
        display: block;
   }

</style>